<template>
  <div :class="['basis-style', isMobile ? '' : 'basis-style-pc']">
    <div
      class="nav-content"
      :style="globalData.runMode? '' : 'background-image:url(' + robotNav.img.url + ')'"
    > <!-- 注意：runMode有值时，不使用下发的背景图 -->
      <div class="nav-title">{{ robotNav.tit }}</div>
      <div class="nav-list">
        <div
          v-for="(item, index) in getPageData(robotNav)"
          :key="index"
          class="nav-item nav-link"
          @click="onClick(item)"
        >
          <div class="nav-item-text">{{ item.name || item.question || "" }}</div>
          <img class="icon-arrow-right" src="../assets/arrow.svg"/>
        </div>
      </div>
      <div v-if="robotNav.showChange" class="nav-change" @click="onChange(robotNav)">
        <div class="nav-change-box">
          <img class="batch-head-icon icon-primay" src="../assets/changeBatch.svg"/>
          换一批
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robotNavMixin from './robot-nav-mixin.js';
/**
 * @component 机器人导航 - 基础型
 */
export default {
  mixins: [robotNavMixin],
};
</script>

<style lang="less" scoped>
.basis-style {
  .nav-content {
    border-radius: 6px;
    padding: 12px 16px 6px 16px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-color: #ffffff;
    .nav-title {
      font-size: 16px;
      color: #262d3d;
      padding-top: 12px;
      line-height: 16px;
      font-weight: bold;
    }
    .nav-list {
      margin-top: 18px;
      .nav-item {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #262d3d;
        font-size: 13px;
        border-bottom: 1px solid #f8f9fb;
        cursor: pointer;
        position: relative;
        .nav-item-text {
          height: 36px;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-arrow-right {
          display: inline-block;
          position: absolute;
          right: 0;
          display: inline-block;
          width: 10px;
          height: 10px;
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .nav-change {
      height: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .nav-change-box {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: @primary;
        cursor: pointer;

        .batch-head-icon {
          height: 12px;
          width: 12px;
          margin-right: 4px;
        }
      }
    }
  }
}
.basis-style-pc {
  width: 336px;
  .nav-content {
    border-radius: 6px;
    box-shadow: 0 1px 10px 0 #e1e6f0;
    margin-top: 2px;
    background-color: #fff;
  }
}
</style>

